import React, { useState } from "react";
import { Link } from "react-router-dom";
import logo1 from "../../../assets/images/logo1.png";
import classes from "./styles.module.scss";
import dopt from '../../../assets/pdf/Dopt_DG Sir_Office_Order.pdf';
import stateTrainingPolicy from '../../../assets/pdf/stateTrainingPolicy.pdf';
import ATI from '../../../assets/pdf/ListOfATIs.pdf';
import Act from '../../../assets/pdf/ACT.pdf';

const mapData = [
  {
    id: "gaya",
    title: "Gaya",
    map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3622.9796737379966!2d84.97675897406423!3d24.761886049197393!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39f32b0621fc9a87%3A0xef0bbbf59d09192f!2sBIPARD%20%5BGAYA%5D!5e0!3m2!1sen!2sin!4v1720242750580!5m2!1sen!2sin",
    social: [
      { href: "https://www.youtube.com/@bipardgaya4894", label: "YouTube", icon: "fa-brands fa-youtube" },
      { href: "https://twitter.com/BipardGaya", label: "X", icon: "fa-brands fa-x-twitter" },
      { href: "https://www.facebook.com/bipard/", label: "Facebook", icon: "fa-brands fa-square-facebook" },
      { href: "https://www.instagram.com/bipard_gaya/", label: "Instagram", icon: "fa-brands fa-instagram" },
      { href: "https://www.linkedin.com/company/bipard-bihar-institute-of-public-administration-rural-development-bipard-gaya", label: "LinkedIn", icon: "fa-brands fa-linkedin" }
    ]
  },
  {
    id: "patna",
    title: "Patna",
    map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3599.0291597454166!2d85.04509927409543!3d25.570696616473732!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39ed56275a98a277%3A0xe534cdccc4d1f734!2sBihar%20Institute%20of%20Public%20Administration%20%26%20Rural%20Development%2C%20WALMI%20Campus!5e0!3m2!1sen!2sin!4v1725363966620!5m2!1sen!2sin",
    social: [
      { href: "https://www.youtube.com/@BIPARDSKILLPARK", label: "YouTube", icon: "fa-brands fa-youtube" },
      { href: "https://www.facebook.com/profile.php?id=61576089536234", label: "Facebook", icon: "fa-brands fa-square-facebook" },
      { href: "https://www.instagram.com/bipardskillpark/", label: "Instagram", icon: "fa-brands fa-instagram" }
    ]
  }
];

const Footer = () => {
  const [mapTab, setMapTab] = useState(0);
  const currentMap = mapData[mapTab];

  return (
    <footer className={classes.footer} role="contentinfo" aria-label="BIPARD footer">
      <div className={classes.container}>
        {/* branding */}
        <div className={classes.brandCard}>
          <Link to="/" className={classes.brandLink} aria-label="BIPARD Home">
            <img src={logo1} alt="BIPARD logo" className={classes.logo} />
            <div className={classes.brandText}>
              <h3>Bihar Institute of Public Administration &amp; Rural Development</h3>
            </div>
          </Link>

          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", width: "100%", marginTop: "12px" }}>
            <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
              <div style={{ fontSize: 13, color: "var(--muted)", fontWeight: 600 }}>Official Social</div>
              <div style={{ display: "flex", gap: "10px", alignItems: "center", flexWrap: "wrap" }}>
                {currentMap.social.map((s) => (
                  <a
                    key={s.href}
                    className={classes.socialBtn}
                    href={s.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={`${s.label} ${currentMap.title}`}
                  >
                    <i className={s.icon} />
                  </a>
                ))}
              </div>
            </div>

            <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: "8px" }}>
              <div style={{ fontSize: 13, color: "var(--muted)", fontWeight: 600 }}>Campus</div>
              <div style={{ display: "flex", gap: 8 }}>
                {mapData.map((m, idx) => (
                  <button
                    key={m.id}
                    onClick={() => setMapTab(idx)}
                    aria-pressed={mapTab === idx}
                    style={{
                      padding: "8px 12px",
                      borderRadius: 10,
                      border: mapTab === idx ? `1px solid var(--accent)` : `1px solid rgba(255,255,255,0.06)`,
                      background: mapTab === idx ? "linear-gradient(180deg,var(--panel-2),transparent)" : "transparent",
                      color: mapTab === idx ? "#fff" : "var(--muted)",
                      cursor: "pointer",
                      fontSize: 13,
                      fontWeight: 600,
                      boxShadow: mapTab === idx ? "0 6px 18px rgba(0,0,0,0.5)" : "none",
                    }}
                  >
                    {m.title}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* explore links */}
        <nav className={classes.linkCard} aria-label="Explore links">
          <h4>Explore</h4>
          <ul>
            <li><a href="https://secc.gov.in/getSeccDataSummaryStateReport.htm/10" target="_blank" rel="noopener noreferrer">SECC-2011 Booklet</a></li>
            <li><a href={dopt} target="_blank" rel="noopener noreferrer">National Training Policy: DoPT</a></li>
            <li><a href={stateTrainingPolicy} target="_blank" rel="noopener noreferrer">State Training Policy</a></li>
            <li><a href={ATI} target="_blank" rel="noopener noreferrer">List of ATIs</a></li>
            <li><a href="https://bvm.bihar.gov.in/reportcard/" target="_blank" rel="noopener noreferrer">Bihar Report Card</a></li>
          </ul>
        </nav>

        {/* quick links */}
        <nav className={classes.linkCard} aria-label="Quick links">
          <h4>Quick Links</h4>
          <ul>
            <li><Link to="/visitus">Contact Us</Link></li>
            <li><a href={Act} target="_blank" rel="noopener noreferrer">RTPS Act</a></li>
            <li><a href="http://bpsm.bihar.gov.in/assets/Home.aspx?P1=3&P2=0&P3=79&P4=3" target="_blank" rel="noopener noreferrer">Assets Declaration</a></li>
            <li><a href="https://erp.bipard.co.in/citizen-survey/bihar-vision-document" target="_blank" rel="noopener noreferrer">Survey Form</a></li>
            <li><Link to="/privacy_policy">Privacy & Policy</Link></li>
            <li><Link to="/detete_account">Delete User</Link></li>
          </ul>
        </nav>

        {/* map section */}
        <div className={classes.mapCard}>
          <div className={classes.mapHeader}>
            <div className={classes.mapTitle}>
              <h4>Location</h4>
              <span className={classes.mapSubtitle}>{currentMap.title}</span>
            </div>
          </div>

          <div className={classes.mapFrame}>
            <iframe
              title={`map-${currentMap.title}`}
              src={currentMap.map}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              aria-label={`Map for ${currentMap.title}`}
              tabIndex={-1}
            />
          </div>
        </div>
      </div>

      <div className={classes.legal}>
        <p>&copy; {new Date().getFullYear()} Bihar Institute of Public Administration &amp; Rural Development. All rights reserved.</p>
        <p>Designed &amp; Developed by <a href="https://codebuckets.in/" target="_blank" rel="noopener noreferrer">Codebucket Solutions Pvt. Ltd</a></p>
      </div>
    </footer>
  );
};

export default Footer;
